export class OnlinePayementInfo {
  action: string;
  version: string;
  tpe: string;
  date: string;
  contexte_commande: string;
  montant: string;
  reference: string;
  url_retour: string;
  url_retour_ok: string;
  url_retour_err: string;
  lgue: string;
  societe: string;
  textelibre: string;
  mail: string;
  sOptions: string;
  sNbrEch: string;
  sDateEcheance1: string;
  sMontantEcheance1: string;
  sDateEcheance2: string;
  sMontantEcheance2: string;
  sDateEcheance3: string;
  sMontantEcheance3: string;
  sDateEcheance4: string;
  sMontantEcheance4: string;
  mac: string;
  dataToValidate: string;
}
